package music.limasoul.client.shared.user.data.repository

import com.russhwolf.settings.ExperimentalSettingsApi
import com.russhwolf.settings.Settings
import com.russhwolf.settings.serialization.decodeValueOrNull
import com.russhwolf.settings.serialization.encodeValue
import com.russhwolf.settings.serialization.removeValue
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.serialization.ExperimentalSerializationApi
import music.jammers.shared.user.domain.model.User
import music.jammers.shared.user.domain.model.UserProfileUpdateData
import music.limasoul.client.shared.user.domain.repository.UserRepository

@OptIn(ExperimentalSerializationApi::class, ExperimentalSettingsApi::class)
internal class UserRepositoryImpl(
    private val settings: Settings,
    private val client: HttpClient,
) : UserRepository {

    override suspend fun update(userProfileUpdateData: UserProfileUpdateData): User {
        val user = client.put("profile") {
            contentType(ContentType.Application.Json)
            setBody(userProfileUpdateData)
        }.body<User>()

        save(user)

        return user
    }

    override suspend fun getCurrent(): User =
        getFromLocal()
            ?: getFromRemote().apply {
                save(this)
            }

    override suspend fun get(userId: Long): User =
        client.get("users/$userId").body<User>()

    override fun clear() {
        settings.removeValue(User.serializer(), PROFILE_KEY)
    }

    private fun getFromLocal(): User? =
        settings.decodeValueOrNull(User.serializer(), PROFILE_KEY)

    private suspend fun getFromRemote(): User =
        client.get("profile").body<User>()

    private fun save(user: User) {
        settings.encodeValue(User.serializer(), PROFILE_KEY, user)
    }

    private companion object {

        const val PROFILE_KEY = "PROFILE_KEY"
    }
}